enum DefaultCssSelectors {
  inlineCtaClassName = ".au-widget-trade-in",
  inlineFormClassName = ".au-trade-in-form-inline-auto",
  bookTestDriveCtaClassName = ".au-book-test-drive-cta",
  similarCarsWidgetClassName = ".au-widget-similar-cars",
  callToActionArea = ".auws-cta-area-TO-BE-REMOVED",
  conversionBox = ".auws-cta-area",
  bookTestDriveFormClassName = ".au-test-drive-form",
  priceAlertWidget = ".auws-price-alert-widget",
  priceAlertCtaClassName = ".auws-price-alert-cta",
}

export default DefaultCssSelectors
